'use client';
import Link from 'next/link';
import Image from 'next/image';
import { FaRegCirclePlay } from 'react-icons/fa6';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { VscClose } from 'react-icons/vsc';
import VideoPlayer from '@/components/videoPlayer/videoPlayer';
import './coreVideo.scss';

interface CoreVideoProps {
  videoUrl?: string;
  imageSrc?: string;
  blurDataURL?: string;
}

export default function CoreVideo({
  videoUrl,
  imageSrc,
  blurDataURL,
}: CoreVideoProps) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <div className="videoWrap">
      <Link
        href="#"
        role="button"
        aria-label="Play video"
        onClick={(e) => {
          e.preventDefault();
          setModalShow(true);
        }}
      >
        <Image
          src={imageSrc || '/n_images/default-blog.jpg'}
          alt="Thumbnail image for video"
          width={800}
          height={400}
          quality={100}
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
        <span className="playIcon" aria-hidden="true">
          <FaRegCirclePlay />
        </span>
      </Link>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        aria-modal="true"
        role="dialog"
        centered
        className="video-modal"
      >
        <Modal.Body className="video-modal-body">
          <Button
            variant="text"
            onClick={() => setModalShow(false)}
            className="close-btn"
          >
            <VscClose />
          </Button>
          <VideoPlayer url={videoUrl ?? ''} />
        </Modal.Body>
      </Modal>
    </div>
  );
}
